const GoRendezVousWidget = () => {
  return (
    <a 
      href="https://www.gorendezvous.com/BookingWidget/?companyId=138849&source=WebSite&sourcedetails=lateliersecret.ca"
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center justify-center bg-taupe text-white px-8 py-4 rounded-none font-sans text-sm uppercase tracking-wider font-medium hover:bg-taupe-dark transition-colors whitespace-nowrap"
      data-testid="gorendezvous-widget"
    >
      Prendre rendez-vous
    </a>
  );
};

export default GoRendezVousWidget;
